import { useGetLegalDocument } from '@/api/auth/legal-documents/legal-documents';

/**
 * Hook to fetch legal document content from its URL.
 * First fetches the document URL from the API, then fetches the HTML content from that URL.
 */
export function useLegalDocumentContent(
  documentType: string,
  version: string,
  language: string,
  options?: { enabled?: boolean }
) {
  const enabled = options?.enabled ?? true;

  // First, get the document URL from the API
  const {
    data: urlResponse,
    isLoading: isLoadingUrl,
    error: urlError,
  } = useGetLegalDocument(documentType, version, language, {
    query: {
      enabled: enabled && !!documentType && !!version && !!language,
    },
  });


  return {
    content: urlResponse ? urlResponse.data : null,
    isLoading: isLoadingUrl,
    error: urlError,
  };
}
